import { AlertTriangle } from "lucide-react";
import { chartSource } from "@/lib/tank";
import { useT } from "@/lib/i18n";

const LABEL = { maker: "Maker chart", epa: "EPA permit", custom: "Custom dimensions", generic: "Generic estimate" };

export function ChartSource({ s, r, testid = "chart-source" }) {
  const t = useT();
  const src = chartSource(s, r);
  return (
    <div className="chart-source" data-testid={testid} data-source={src}>
      <span className={`chart-source-tag src-${src}`} data-testid={`${testid}-label`}>{t("Chart source")}: {t(LABEL[src])}</span>
      {(src === "generic" || src === "epa") && (
        <p className="chart-source-note" data-testid={`${testid}-generic-note`} role="note">
          <AlertTriangle size={14} />{t("Generic size chart — actual tank may differ. Pick the exact maker/model or enter diameter & length for best accuracy.")}
        </p>
      )}
    </div>
  );
}
